module.exports = __webpack_public_path__ + "health2.3N053mSQ.svg";